import makeStateFilter from '../../make-state-filter';

import { stateFilter as parentStateFilter } from '../reducer.metadata';

const namespace = 'ltl';
const stateFilter = makeStateFilter(parentStateFilter, namespace);

export { namespace, stateFilter };
